import { normalizeBusinessAccountIds } from '@/utils/utils'

export function normalizeEnterpriseAccountId(value) {
  const [normalizedId] = normalizeBusinessAccountIds([value])
  return normalizedId || null
}

export function normalizeEnterpriseAccountOption(account) {
  if (!account || typeof account !== 'object') return null

  const optionId =
    account.id !== undefined && account.id !== null
      ? account.id
      : account.value
  const normalizedId = normalizeEnterpriseAccountId(optionId)
  if (!normalizedId) return null

  const labelSource = account.label || account.name || normalizedId
  const normalizedLabel = String(labelSource || normalizedId).trim() || normalizedId

  return {
    ...account,
    id: normalizedId,
    value: normalizedId,
    label: normalizedLabel,
    name: account.name || account.label || normalizedLabel,
  }
}

export function normalizeEnterpriseAccountsSearchTerm(searchTerm = '') {
  return String(searchTerm || '').trim().toLowerCase()
}

export function normalizeEnterpriseAccountsPage(page = null) {
  if (page === null || page === undefined) return null
  const normalizedPage = String(page).trim()
  return normalizedPage || null
}

export function getLoadedEnterpriseAccountIdsSet(options = []) {
  return (Array.isArray(options) ? options : []).reduce((acc, option) => {
    const optionId =
      option && option.value !== undefined && option.value !== null
        ? option.value
        : option && option.id
    const normalizedId = normalizeEnterpriseAccountId(optionId)
    if (normalizedId) {
      acc.add(normalizedId)
    }
    return acc
  }, new Set())
}

export function getMissingSelectedEnterpriseAccountIds(
  selectedIds = [],
  loadedOptions = []
) {
  const normalizedSelectedIds = normalizeBusinessAccountIds(selectedIds)
  if (!normalizedSelectedIds.length) return []

  const loadedIds = getLoadedEnterpriseAccountIdsSet(loadedOptions)
  return normalizedSelectedIds.filter((id) => !loadedIds.has(id))
}

export function mergeEnterpriseAccountOptionsInPlace(
  targetOptions = [],
  incomingAccounts = []
) {
  if (!Array.isArray(targetOptions)) return []

  const optionsById = targetOptions.reduce((acc, option) => {
    const normalizedOption = normalizeEnterpriseAccountOption(option)
    if (!normalizedOption) return acc

    option.id = normalizedOption.id
    option.value = normalizedOption.value
    option.label = normalizedOption.label
    option.name = normalizedOption.name
    acc[normalizedOption.value] = option
    return acc
  }, {})

  incomingAccounts.forEach((account) => {
    const normalizedOption = normalizeEnterpriseAccountOption(account)
    if (!normalizedOption) return

    const existingOption = optionsById[normalizedOption.value]
    if (existingOption) {
      existingOption.label = normalizedOption.label
      existingOption.name = normalizedOption.name
      existingOption.id = normalizedOption.id
      existingOption.value = normalizedOption.value
      return
    }

    optionsById[normalizedOption.value] = normalizedOption
    targetOptions.push(normalizedOption)
  })

  return targetOptions
}
